import styles from './Loader.module.scss';
import { LoaderProps } from './types';

export const Loader = ({
	backgroundColor = 'rgba(255,255,255,0.5)',
	color = '#0067b3',
	size = 50,
	stroke = 5,
}: LoaderProps) => {
	return (
		<div style={{ backgroundColor }} className={styles.loader}>
			<div
				style={{
					height: size,
					width: size,
					borderStyle: 'solid',
					borderWidth: `${stroke}px`,
					borderColor: `${color} transparent transparent ${color}`,
				}}
				className={styles.loader__spinner}
			/>
		</div>
	);
};
